import { render, staticRenderFns } from "./downPlug.vue?vue&type=template&id=0b3eacd6&scoped=true"
import script from "./downPlug.vue?vue&type=script&lang=js"
export * from "./downPlug.vue?vue&type=script&lang=js"
import style0 from "./downPlug.vue?vue&type=style&index=0&id=0b3eacd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3eacd6",
  null
  
)

export default component.exports